module.exports = __webpack_public_path__ + "static/media/koa.4f14891b.png";